import api from './api';

export const profileApi = {
  getProfile: async () => {
    try {
      const response = await api.get('/profile');
      return { data: response.data, error: null };
    } catch (error) {
      return {
        data: null,
        error: error.response?.data?.error || 'Failed to fetch profile',
      };
    }
  },

  updatePersonalInfo: async (personalInfo) => {
    try {
      const response = await api.put('/profile/personal-info', personalInfo);
      return { data: response.data, error: null };
    } catch (error) {
      return {
        data: null,
        error: error.response?.data?.error || 'Failed to update personal information',
      };
    }
  },

  updateMedicalList: async (listType, action, item, index) => {
    try {
      const response = await api.put(`/profile/medical-info/${listType}`, {
        action,
        item,
        ...(action === 'remove' && { index }),
      });
      return { data: response.data, error: null };
    } catch (error) {
      return {
        data: null,
        error: error.response?.data?.error || 'Failed to update medical list',
      };
    }
  },

  updateLifestyle: async (lifestyleData) => {
    try {
      const response = await api.put('/profile/lifestyle', lifestyleData);
      return { data: response.data, error: null };
    } catch (error) {
      return {
        data: null,
        error: error.response?.data?.error || 'Failed to update lifestyle information',
      };
    }
  },

  bulkUpdateProfile: async (profileData) => {
    try {
      const response = await api.put('/profile', profileData);
      return { data: response.data, error: null };
    } catch (error) {
      return {
        data: null,
        error: error.response?.data?.error || 'Failed to update profile',
      };
    }
  },
}; 